import React from 'react';
import { Link } from 'react-router-dom';
import { RESERVATIONS_ROUTE } from '../router/routes';

function BookingDonePage({ location }) {
  const { state } = location;

  return (
    <>
      <h3 className="text-center pb2">
        Skvělé! Našli jsme pro Vás parkovací místo {state.place}
      </h3>
      <div className="card">
        <div className="card__header">
          <div className="col-6">
            <i className="fas fa-map-marker-alt" />
            <span className="ml1">{state.lotName}</span>
          </div>
          <div className="col-6">
            <i className="far fa-calendar" />
            <span className="ml1">{state.reservationDate}</span>
          </div>
        </div>
        <div className="card__body">
          <div className="card__row sm-flex">
            <div className="col-6">
              <i className="far fa-address-card" />
              <span className="card__row--label ml1">SPZ</span>
              <span className="ml1">{state.plateNo}</span>
            </div>
            <div className="col-6">
              <i className="far fa-clock" />
              <span className="card__row--label ml1">Čas</span>
              <span className="ml1">
                {state.timeFrom} - {state.timeTo}
              </span>
            </div>
          </div>
          <div className="card__row sm-flex">
            <div className="col-6">
              <i className="fas fa-grip-lines" />
              <span className="card__row--label ml1">Patro</span>
              <span className="ml1">{state.floor}</span>
            </div>
            <div className="col-6">
              <i className="fas fa-map-pin" />
              <span className="card__row--label ml1">Mapa</span>
              <span className="ml1">
                <a
                  href={`https://www.google.com/maps/place/${state.latitude}+${state.longitude}`}
                  target="__blank"
                >
                  otevřít
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center pt3">
        <Link to={RESERVATIONS_ROUTE} className="btn">
          Přehled rezervací
        </Link>
      </div>
    </>
  );
}

export default BookingDonePage;
